import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../styles/Layouts';
import { motion } from 'framer-motion';
import conversation from '../assets/conversation.svg';

function ReviewSection() {
  return (
    <ReviewSectionStyled id="review">
      <InnerLayout>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: '0.5' }}
        >
          <div className="review-container">
            <div className="left-items">
              <h2 className="secondary-heading">We have a great group of people, that always want to improve</h2>
              <p>
                Here we want to improve ourselfs, and give you what you need to keep you satisfied, needless to say that
                we have a great team that likes challenges.
              </p>
              <p>
                Everything is to make the webapp better and save you from losing your photos, why not give it a try and
                give us a challenge for our team, to make it even better, for us and for you.
              </p>
            </div>
            <div className="right-items">
              <div className="image-container">
                <img src={conversation} alt="" className="c-text" />
              </div>
            </div>
          </div>
        </motion.div>
      </InnerLayout>
    </ReviewSectionStyled>
  );
}

const ReviewSectionStyled = styled.section`
  .review-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    @media screen and (max-width: 1347px) {
      grid-template-columns: repeat(1, 1fr);
    }

    .left-items {
      padding-right: 2rem;
      @media screen and (max-width: 787px) {
        padding-right: 0;
      }
      p {
        padding: 2rem 0;
      }
    }
    .right-items {
      padding-right: 2rem;
      padding-top: 8rem;
      position: relative;

      img {
        width: 90%;
      }
    }
  }
`;

export default ReviewSection;
